<template>
  <v-container>
    <v-layout align-center column>
      <div>
        <v-icon large>warning</v-icon>
      </div>
      <h4 class="display-1">Unauthorized</h4>
    </v-layout>
  </v-container>
</template>
<script>
export default {};
</script>
